import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  replyPostWrapper: {},

  optionItem: {
    color: theme.palette.grey[600] + ' !important',
  },
  checked: {
    color: theme.palette.primary.main + ' !important',
  },
  replyPostBottom: {
    marginTop: 8,
    display: 'flex',
    justifyContent: 'space-between',
  },
  community: {
    maxWidth: 'unset',
  },
}));
